module.exports = __webpack_public_path__ + "static/img/1_1_2_1.915134f4.jpg";